var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSignInImage = function SvgSignInImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 423,
    height: 223,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#signIn_image_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3F74FF",
    d: "M0 14A14 14 0 0 1 14 0h395a14 14 0 0 1 14 14v209H0V14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M98.3 64.4-2 30v48l113.5 23 25.7 6c1.2.4 2.4.5 3.6.5h.8a14.5 14.5 0 0 0 5.6-27.8l-8.2-3.5a2.7 2.7 0 0 0 2.5-2.7v-1.1a4 4 0 0 0-3.4-3.9l-18.6-2.8-3-.2h-11.7a20 20 0 0 1-6.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2148AE",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "m119.5 78 19.5-1.8m0 0v0a2.7 2.7 0 0 0 2.5-2.7v-1.1a4 4 0 0 0-3.4-3.9l-18.6-2.8-3-.2h-11.7a20 20 0 0 1-6.5-1L-2 30v48l113.5 23 25.7 6c1.2.4 2.4.5 3.6.5h.8c6.7 0 12.5-4.6 14-11.1v0c1.7-6.9-1.9-14-8.4-16.7l-8.2-3.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 76,
    x: 138.7,
    y: 46.7,
    fill: "#fff",
    stroke: "#2148AE",
    strokeWidth: 4,
    rx: 9,
    transform: "rotate(30 138.7 46.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M120.7 65.5h-16.5l2.1 18.2 16-5.7 19.4-1.8 2.5-.2v-7l-23.5-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2148AE",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M104.2 65.5h15c1 0 2 0 3 .2l18.7 2.8a4 4 0 0 1 3.3 3.9v1c0 1.5-1 2.7-2.5 2.8v0l-24.1 2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3364E2",
    d: "M270.2 146.8c-33.4 58.3-115.9 43.5-160.2 0-30-29.6-79.4-23.2-110-13.3V223h423V42.3c-5.7-3.9-11.5-6.3-17.4-6.8-48.2-3.9-102 53-135.4 111.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.5,
    cy: 187.5,
    r: 5.5,
    stroke: "#3F74FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 207.5,
    r: 5.5,
    stroke: "#3F74FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.5,
    cy: 18.5,
    r: 5.5,
    stroke: "#3363E2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.5,
    cy: 64.5,
    r: 5.5,
    stroke: "#3363E2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 16.5,
    r: 5.5,
    stroke: "#3363E2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 109.5,
    r: 5.5,
    stroke: "#3363E2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3363E2",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m197 147 8 8m0-8-8 8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3F74FF",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m385 139 8 8m0-8-8 8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3363E2",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m142 15 8 8m0-8-8 8m151 8 8 8m0-8-8 8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M315 72.6 433 32v56.4l-133 27-30.1 7.1c-1.4.3-2.8.5-4.2.5h-.8a17 17 0 0 1-6.7-32.6l9.6-4.1c-1.6-.2-2.9-1.6-2.9-3.2v-1.3c0-2.3 1.7-4.3 4-4.6l22-3.3 3-.2h14.5a20 20 0 0 0 6.5-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2148AE",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "m290.7 88.4-22.9-2.1m0 0v0c-1.6-.2-2.9-1.6-2.9-3.2v-1.3c0-2.3 1.7-4.3 4-4.6l22-3.3 3-.2h14.5a20 20 0 0 0 6.5-1.1L433 32v56.4l-133 27-30.1 7.1c-1.4.3-2.8.5-4.2.5h-.8a17 17 0 0 1-16.6-13v0a17 17 0 0 1 10-19.6l9.5-4.1ZM249.5 104l22-8m-20 17 24-7.5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#signIn_image_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2148AE",
    d: "M148.5 77.2c2.7-.8 5.6-.6 8 .5a10.9 10.9 0 0 1 6 13.4c-.8 2.7-2.5 4.9-5 6.3-1.7 1.1-3.6 1.7-5.7 1.8l-8.5 14.7a7 7 0 0 1-4.2 3.3c-1.4.4-2.9.2-4.1-.5a5.2 5.2 0 0 1-2.6-3.1 6.5 6.5 0 0 1 .7-5.2l.7-1.2c.4-.7 1-1.2 1.9-1.5l2.3-.6-.4-1.5a3 3 0 0 1 .3-2.3c.4-.7 1-1.2 1.8-1.4l1.5-.4-.6-2.3a2.9 2.9 0 0 1 .3-2.3l.7-1.2c-1-1.7-1.6-3.6-1.6-5.6 0-2.2.8-4.4 2-6.3a11.8 11.8 0 0 1 6.5-4.6Zm5.3 18.7a8.7 8.7 0 0 0 4-2.5 8 8 0 0 0-1-12.1 8.8 8.8 0 0 0-12.3 2.4 8.2 8.2 0 0 0-1.4 4.4c0 1.7.5 3.3 1.5 4.7a1.4 1.4 0 0 1 .1 1.6l-1.2 2 .7 2.2a3 3 0 0 1-.3 2.3c-.4.7-1 1.2-1.8 1.4l-1.5.5.4 1.4a3 3 0 0 1-.3 2.3c-.4.7-1 1.2-1.9 1.4l-2.3.7-.7 1.2a3.8 3.8 0 0 0-.4 3c.2.5.6 1 1.1 1.3.5.3 1.2.4 1.8.2a4 4 0 0 0 2.4-1.8l9-15.5a1.6 1.6 0 0 1 1.3-.8c1 0 2 0 2.9-.3Zm.9-11.2c0-.2-.3-.5-.5-.7-.2-.2-.5-.3-.8-.3a1.6 1.6 0 0 0-1.5.8c-.2.2-.3.5-.2.8a1.5 1.5 0 0 0 1 1.3 1.6 1.6 0 0 0 1.8-.7c.2-.4.3-.8.2-1.2Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "signIn_image_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h423v223H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "signIn_image_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M169.5 108.4 134 118.7l-10-34.5L159.8 74z"
  })))));
};
export default SvgSignInImage;